export const getAltName = (speakerType?: string | null, brandCustomerTitle?: string | null): string => {
  if (speakerType === "local" || brandCustomerTitle === "Orients") return "un guide local francophone";

  if (brandCustomerTitle === "Sentiers des Arts") return "un guide culturel Sentiers des Arts";

  if (brandCustomerTitle === "Intermèdes") return "un conférencier Intermèdes";

  return "un conférencier";
};
